import { Form, Select, Tag } from 'antd';
import { ISettingToUpdate, ISettingType } from '../../interfaces/TenantSetting'; //
import { EnumsValues } from '../../enums/EnumsValues';
import { useTranslation } from 'react-i18next';

type Props = {
  settingsArray: ISettingToUpdate[];
  handleChange: (id: any, value: any) => void;
  stringSeparators?: string[];
  setValidationState: (isValid: boolean) => void;
};
const defaultStringSeparators = [',', ' ', ';', '|'];

const isValidEmail = (email: string) => {
  return new RegExp(EnumsValues.RegexPattern.EmailWithAlias).test(email);
};

export const useSettingEmailArrayInput = (props: Props) => {
  const [t] = useTranslation();
  const { settingsArray, handleChange, stringSeparators, setValidationState } =
    props;
  const onInputChange = (id: number | undefined, e: string[]) => {
    const valueToSave = JSON.stringify(e);
    const hasValidEmails = e.every((email) => isValidEmail(email));
    setValidationState(hasValidEmails);
    handleChange(id, valueToSave);
  };

  const emailArrayTypeSetting: ISettingType = {
    render: (props) => {
      const valueSelected = settingsArray.find(
        (item) => item.id === props.id,
      )?.value;

      let valueAsArray: string[] = [];

      if (valueSelected) {
        try {
          valueAsArray = JSON.parse(valueSelected);
        } catch (error) {
          /* Intentional */
        }
      }

      return (
        <Form.Item
          className="margin-component"
          help={
            valueAsArray.some((email) => !isValidEmail(email)) ? (
              <span style={{ color: 'red' }}>
                {t('emailArrayInput.formatErrorMessage')}
              </span>
            ) : (
              ''
            )
          }
        >
          <Select<string[]>
            value={valueAsArray}
            mode="tags"
            tokenSeparators={stringSeparators || defaultStringSeparators}
            onChange={(e) => onInputChange(props.id, e)}
            options={[]}
            tagRender={({ label, value, closable, onClose }) => (
              <Tag
                color={isValidEmail(value) ? 'default' : 'red'}
                closable={closable}
                onClose={onClose}
                style={{ padding: '2px 8px', fontSize: '14px' }}
              >
                {label}
              </Tag>
            )}
          />
        </Form.Item>
      );
    },
  };

  return { emailArrayTypeSetting };
};
